var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { isNil, merge, noop } from 'lodash-es';
import { findAncestor } from '../node/utilities';
import { SdsTreeCellBase } from './_sds-tree-cell-base';
/**
 * Base class for a data cell in a tree component.
 * Provides functionality for handling text overflow with an ellipsis, and for displaying a popover with the full text on hover.
 *
 * @abstract
 */
let SdsTreeDataCellBase = (() => {
    var _a, _SdsTreeDataCellBase_value_accessor_storage, _SdsTreeDataCellBase_ellipsis_accessor_storage, _SdsTreeDataCellBase_dataType_accessor_storage, _SdsTreeDataCellBase_isHidden_accessor_storage;
    let _classSuper = SdsTreeCellBase;
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _ellipsis_decorators;
    let _ellipsis_initializers = [];
    let _ellipsis_extraInitializers = [];
    let _dataType_decorators;
    let _dataType_initializers = [];
    let _dataType_extraInitializers = [];
    let _isHidden_decorators;
    let _isHidden_initializers = [];
    let _isHidden_extraInitializers = [];
    return _a = class SdsTreeDataCellBase extends _classSuper {
            constructor() {
                super(...arguments);
                _SdsTreeDataCellBase_value_accessor_storage.set(this, __runInitializers(this, _value_initializers, ''));
                _SdsTreeDataCellBase_ellipsis_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, _ellipsis_initializers, false)));
                _SdsTreeDataCellBase_dataType_accessor_storage.set(this, (__runInitializers(this, _ellipsis_extraInitializers), __runInitializers(this, _dataType_initializers, 'radio')));
                /**
                 * Handles cell resize events.
                 */
                this.handleResize = (__runInitializers(this, _dataType_extraInitializers), noop);
                _SdsTreeDataCellBase_isHidden_accessor_storage.set(this, __runInitializers(this, _isHidden_initializers, false));
                this.firstUpdatedOccurred = (__runInitializers(this, _isHidden_extraInitializers), false);
                this.isContentResizeObserverActive = false;
            }
            /**
             * Represents the value of a data cell.
             * @attr
             */
            get value() { return __classPrivateFieldGet(this, _SdsTreeDataCellBase_value_accessor_storage, "f"); }
            set value(value) { __classPrivateFieldSet(this, _SdsTreeDataCellBase_value_accessor_storage, value, "f"); }
            /**
             * Indicates whether overlapping text should be represented as a popover with ellipsis.
             * @attr ellipsis
             */
            get ellipsis() { return __classPrivateFieldGet(this, _SdsTreeDataCellBase_ellipsis_accessor_storage, "f"); }
            set ellipsis(value) { __classPrivateFieldSet(this, _SdsTreeDataCellBase_ellipsis_accessor_storage, value, "f"); }
            /**
             * The data type of cell, used for identifying the corresponding icon..
             *
             * @attr data-type
             */
            get dataType() { return __classPrivateFieldGet(this, _SdsTreeDataCellBase_dataType_accessor_storage, "f"); }
            set dataType(value) { __classPrivateFieldSet(this, _SdsTreeDataCellBase_dataType_accessor_storage, value, "f"); }
            get isHidden() { return __classPrivateFieldGet(this, _SdsTreeDataCellBase_isHidden_accessor_storage, "f"); }
            set isHidden(value) { __classPrivateFieldSet(this, _SdsTreeDataCellBase_isHidden_accessor_storage, value, "f"); }
            get parentTreeNode() {
                return this._parentTreeNode;
            }
            get dataId() {
                return this._dataId;
            }
            getClasses() {
                return classMap(merge({
                    'sds-tree__cell': true,
                    'sds-tree__cell--ellipsis': this.ellipsis,
                    'sds-tree__cell--sum': this.dataType === 'sum',
                }, this.getCustomClasses()));
            }
            async firstUpdated() {
                await this.updateComplete;
                this.firstUpdatedOccurred = true;
            }
            async connectedCallback() {
                super.connectedCallback();
                this._parentTreeNode = findAncestor(this, 'sds-tree-node');
                await this.updateComplete;
                await this.registerInHierarchicalState();
                const textContainer = this.getTextContainer();
                if (!isNil(textContainer) && !this.isContentResizeObserverActive) {
                    this.isContentResizeObserverActive = true;
                }
            }
            disconnectedCallback() {
                super.disconnectedCallback();
                this.removeFromHierarchicalState();
                this.isContentResizeObserverActive = false;
            }
            willUpdate(changedProperties) {
                super.willUpdate(changedProperties);
                if (changedProperties.has('row-position') || changedProperties.has('col-position')) {
                    this.updateInHierarchicalState();
                }
            }
            /**
             * @returns An object representing custom CSS classes.
             */
            getCustomClasses() {
                return {};
            }
            async registerInHierarchicalState() {
                var _b, _c, _d, _e, _f;
                await ((_b = this.parentTreeNode) === null || _b === void 0 ? void 0 : _b.nodeIsReady);
                const parentId = (_c = this.parentTreeNode) === null || _c === void 0 ? void 0 : _c.nodeId;
                if (!isNil(parentId)) {
                    this._dataId = (_f = (_e = (_d = this.tree) === null || _d === void 0 ? void 0 : _d.hierarchicalState) === null || _e === void 0 ? void 0 : _e.getNode(parentId)) === null || _f === void 0 ? void 0 : _f.addData({
                        rowPosition: this.rowPositionForState(),
                        columnPosition: this.colPositionForState(),
                    });
                }
            }
            updateInHierarchicalState() {
                var _b, _c, _d, _e;
                const parentId = (_b = this.parentTreeNode) === null || _b === void 0 ? void 0 : _b.nodeId;
                if (!isNil(parentId) && !isNil(this.dataId)) {
                    (_e = (_d = (_c = this.tree) === null || _c === void 0 ? void 0 : _c.hierarchicalState) === null || _d === void 0 ? void 0 : _d.getNode(parentId)) === null || _e === void 0 ? void 0 : _e.updateData(this.dataId, {
                        rowPosition: this.rowPositionForState(),
                        columnPosition: this.colPositionForState(),
                    });
                }
                else if (isNil(this.dataId)) {
                    console.warn('Data cell is not registered in hierarchical state.');
                }
            }
            rowPositionForState() {
                const rowStart = this.rowStart();
                const rowEnd = this.rowEnd();
                if (!isNil(rowStart) && !isNil(rowEnd)) {
                    return { start: rowStart, end: rowEnd };
                }
                else {
                    return undefined;
                }
            }
            colPositionForState() {
                const colStart = this.colStart();
                const colEnd = this.colEnd();
                if (!isNil(colStart) && !isNil(colEnd)) {
                    return { start: colStart, end: colEnd };
                }
                else {
                    return undefined;
                }
            }
            removeFromHierarchicalState() {
                var _b, _c, _d, _e;
                const parentId = (_b = this.parentTreeNode) === null || _b === void 0 ? void 0 : _b.nodeId;
                if (!isNil(parentId) && !isNil(this.dataId)) {
                    (_e = (_d = (_c = this.tree) === null || _c === void 0 ? void 0 : _c.hierarchicalState) === null || _d === void 0 ? void 0 : _d.getNode(parentId)) === null || _e === void 0 ? void 0 : _e.removeData(this.dataId);
                }
            }
        },
        _SdsTreeDataCellBase_value_accessor_storage = new WeakMap(),
        _SdsTreeDataCellBase_ellipsis_accessor_storage = new WeakMap(),
        _SdsTreeDataCellBase_dataType_accessor_storage = new WeakMap(),
        _SdsTreeDataCellBase_isHidden_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _value_decorators = [property({ type: String })];
            _ellipsis_decorators = [property({ type: Boolean })];
            _dataType_decorators = [property({ type: String, attribute: 'data-type' })];
            _isHidden_decorators = [state()];
            __esDecorate(_a, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
            __esDecorate(_a, null, _ellipsis_decorators, { kind: "accessor", name: "ellipsis", static: false, private: false, access: { has: obj => "ellipsis" in obj, get: obj => obj.ellipsis, set: (obj, value) => { obj.ellipsis = value; } }, metadata: _metadata }, _ellipsis_initializers, _ellipsis_extraInitializers);
            __esDecorate(_a, null, _dataType_decorators, { kind: "accessor", name: "dataType", static: false, private: false, access: { has: obj => "dataType" in obj, get: obj => obj.dataType, set: (obj, value) => { obj.dataType = value; } }, metadata: _metadata }, _dataType_initializers, _dataType_extraInitializers);
            __esDecorate(_a, null, _isHidden_decorators, { kind: "accessor", name: "isHidden", static: false, private: false, access: { has: obj => "isHidden" in obj, get: obj => obj.isHidden, set: (obj, value) => { obj.isHidden = value; } }, metadata: _metadata }, _isHidden_initializers, _isHidden_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export { SdsTreeDataCellBase };
